import { Button } from "../../utils/Utils";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";

export class StyleButton extends Phaser.GameObjects.Container {

    private img: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {

        super(scene);

        this.x = x;
        this.y = y;

        let styleText = new Phaser.GameObjects.Text(this.scene, 0, -170, GameVars.gameText.GAME[4], {fontFamily: "HelveticaNeue", fontSize: "40px", color: "#fecf27"});
        styleText.setOrigin(.5);
        this.add(styleText);

        this.img = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "back_deck_" + GameVars.gameData.backStyle);
        this.add(this.img);

        let leftArrow = new Button(this.scene, -120, 0, "texture_atlas_1", "arrow_white", "arrow_white_hover");
        leftArrow.setScale(-1, 1);
        leftArrow.onDown(this.onLeftDown, this);
        this.add(leftArrow);

        let rightArrow = new Button(this.scene, 120, 0, "texture_atlas_1", "arrow_white", "arrow_white_hover");
        rightArrow.onDown(this.onRightDown, this);
        this.add(rightArrow);
    }

    private onLeftDown(): void {

        GameManager.changeStyle(true); 
        this.img.setFrame("back_deck_" + GameVars.gameData.backStyle);
    }

    private onRightDown(): void {

        GameManager.changeStyle(false); 
        this.img.setFrame("back_deck_" + GameVars.gameData.backStyle);
    }
}
